import React, { useEffect, useRef, useState } from 'react';
import Footer from './Footer';
import Checkmark from '../../../assets/checkmark.js';
import { getMarkDown, useDetectMobile, useNextButtonWidthClass, formatCardLoadTiming, getButtonWithArrow } from '../utils';
import '../../../stylesheets/triagebot/SingleNext.scss';
import { useTiming } from '../TimingContext';
import { useCardLoadTiming } from '../hooks/useCardLoadTiming';

//************************************* */

const SingleNextMessage = ({ message, sendMessage, disabled }) => {

  const currentPcp = message?.data?.[1]?.currentPcp || '';


  const [selected, setSelected] = useState({ id: currentPcp.id, name: currentPcp.name });
  const [submitted, setSubmitted] = useState(false);
  const [editing, setEditing] = useState(false);
  const headingRef = useRef(null);

  const questionId = message?.data?.[0]?.question_id;

  const isDisabled = submitted || disabled;

  const Buttons = message?.buttons;

  const headerText = message?.data?.[0]?.headerText;
  const subHeader = message?.data?.[0]?.subHeaderText;
  const hasSubHeader = Boolean(subHeader);
  const subHeaderId = hasSubHeader ? `${questionId || 'single-next'}-subheader` : undefined;

  const nextButton = message?.data?.[0]?.nextButton?.displayText
  ? message.data[0].nextButton.displayText
  : '';

  const { isMobile } = useDetectMobile();
  const nextButtonClass = useNextButtonWidthClass();

  const choicePress = (choose) => {
    if (submitted) return;

    var obj = {
      id: choose.value,
      name: choose.displayText
    }

    setSelected(obj);
  };

  const submitPress = (event) => {
    if (submitted) {
      sendMessage('rewind', questionId, questionId);
      setSubmitted(false);
      setEditing(true);
      return;
    }

    var submitValue = selected.id;

    setSubmitted(true);

    editing
      ? sendMessage('message', `##edit@${message.data[0].question_id}@${submitValue || 'none'}`, `##edit@${message.data[0].question_id}@${submitValue || 'none'}`, cardName)
      : sendMessage('message', submitValue || 'none', submitValue || 'none', cardName);
  };

  const { logTiming } = useTiming();
  const cardName = message?.data?.[0]?.question_id || "Provider";

  useEffect(() => {
    const focusTimer = setTimeout(() => {
      headingRef.current?.focus({ preventScroll: true });
    }, 500);

    return () => clearTimeout(focusTimer);
  }, [cardName]);

   useCardLoadTiming({
                sentAt: message._sentAt,
                cardName,
                logTiming,
                formatCardLoadTiming
            });

  return (
    <div className={isDisabled ? 'disabled multi-select card' : 'multi-select card'}>
      <div className='content' >
        <div className='header' id={questionId}>
          <h2 className='headerText' ref={headingRef} tabIndex={-1}> {getMarkDown(headerText)} </h2>
          {
            hasSubHeader &&
            <div id={subHeaderId} className='subheader'> {getMarkDown(subHeader)} </div>
          }
        </div>

        <div className='body' role='radiogroup' aria-label='Answer options' aria-describedby={subHeaderId}>
          {Buttons.map((choice, key) => {
            const isSelected = selected.id===choice.value;
            return (
              <button
                key={key}
                className={(isMobile ? 'mobile ' : 'desktop ') + (isSelected ? 'multi-button selected' : 'multi-button')}
                onClick={() => choicePress(choice)}
                onMouseDown={(e) => e.preventDefault()}
                disabled={submitted || disabled}
                role='radio'
                aria-checked={isSelected ? 'true' : 'false'}
                aria-label={choice.displayText}
              >
                {
                  (isSelected) &&
                  <Checkmark
                    className='checkmark'
                    role="img"
                    ariaLabelledby={choice.displayText + (isSelected ? "-selected" : "")}
                    id={choice.displayText}
                  />
                }
                <span>{choice.displayText}</span>
              </button>
            );
          })}
        </div>
      </div>

      <Footer
        showChangeButton={questionId && submitted && !message.isLastMessage}
        onAccepted={submitPress}
        onDenied={() => sendMessage('fastforward')}
        disabled={disabled}
        divID={questionId}
        message={message}
      >
        <button
          onClick={submitPress}
          className={`submit-button ${nextButtonClass}`.trim()}
          disabled={isDisabled}
          style={{ visibility: submitted ? 'hidden' : 'visible', 'display': submitted ? 'none' : '' }}
          aria-hidden={submitted ? 'true' : 'false'}
        >
          {getButtonWithArrow(nextButton)}
          </button>
      </Footer>

    </div>
  );
};

export default SingleNextMessage;
